import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {CartHeaderService} from "./cart-header.service";
import {LocaleService} from "../../../../services/locale.service";
import {CartService} from "../../../../services/api/services/cart/cart.service";
import {CoreModule} from "../../../core.module";

@Component({
    selector: 'app-cart-header',
    templateUrl: './cart-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CoreModule]
})
export class CartHeaderComponent implements OnInit, OnDestroy {

  public headerEnabled: boolean = this.cartHeaderService.headerEnabled.value;
  public backButtonEnabled: boolean = this.cartHeaderService.backButtonEnabled.value;
  public nextButtonEnabled: boolean = this.cartHeaderService.nextStepButtonEnabled.value;
  public ticketCount: number | undefined = undefined;

  private headerEnabledSubscription?: Subscription;
  private backButtonEnabledSubscription?: Subscription;
  private nextButtonEnabledSubscription?: Subscription;

  public ngOnInit(): void {
    this.headerEnabledSubscription = this.cartHeaderService.headerEnabled.subscribe({
      next: value => {
        this.headerEnabled = value;
        this.cdr.markForCheck();
      }
    });

    this.backButtonEnabledSubscription = this.cartHeaderService.backButtonEnabled.subscribe({
      next: value => {
        this.backButtonEnabled = value;
        this.cdr.markForCheck();
      }
    });

    this.nextButtonEnabledSubscription = this.cartHeaderService.nextStepButtonEnabled.subscribe({
      next: value => {
        this.nextButtonEnabled = value;
        this.cdr.markForCheck();
      }
    });
  }

  public ngOnDestroy() {
    this.headerEnabledSubscription?.unsubscribe();
    this.backButtonEnabledSubscription?.unsubscribe();
    this.nextButtonEnabledSubscription?.unsubscribe();
  }

  public back(event: MouseEvent) {
    event.preventDefault();
    if (this.backButtonEnabled) {
      history.back();
    }
  }

  public gotToCart($event: Event): void {
    $event.preventDefault();
    this.router.navigateByUrl(this.localeService.localizedPath('/summary'));

  }

  public constructor(
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly localeService: LocaleService,
    private readonly cartService: CartService,
    private readonly cartHeaderService: CartHeaderService
  ) {

    this.cartService.ticketCount$.subscribe({
      next: value => {
        this.ticketCount = value;
        this.cdr.markForCheck();
      }
    });
  }
}
